import { api } from "./client";

/** GET /images/{id}/cloud/summary — what the point cloud behind a ToF capture holds. */
export interface CloudSummary {
  image_id: number; width: number; height: number; valid_points: number; valid_fraction: number;
  plane_found: boolean; plane_inliers: number; plane_error: string | null; meta: Record<string, unknown>;
}
export const cloudSummary = (imageId: number) => api.get<CloudSummary>(`/images/${imageId}/cloud/summary`);

/** GET /images/{id}/cloud/depth — height above the belt, as a PNG on the same grid as the image. */
export const cloudDepthBlob = (imageId: number, signal?: AbortSignal) => api.get<Blob>(`/images/${imageId}/cloud/depth`, { as: "blob", signal });
